import { ApplyEngagementBlueprintButton } from "PFApp/activities/engagement_blueprint/components/apply_engagement_blueprint_button";
import { AddRoleButton } from "PFApp/activities/show/parts/add_role_button";
import { TemplateKey } from "PFApp/constants/templates";
import { Inline, Stack } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import NoRolesIllustration from "PFTheme/graphics/illustrations/illustration-no-roles.svg";
import { Activity } from "PFTypes";
import { useTranslation } from "react-i18next";

import AddCoOwner from "../../../../parts/add_co_owner";
import css from "./no_linked_roles.module.scss";

type NoLinkedRolesProps = {
  activity: Activity;
  showActions?: boolean;
  canCreateRoles?: boolean;
  roleKey: TemplateKey.Role | TemplateKey.AuditRole;
};

export const NoLinkedRoles = ({
  activity,
  showActions = true,
  canCreateRoles = true,
  roleKey
}: NoLinkedRolesProps) => {
  const { t } = useTranslation("activities");

  return (
    <Stack center gap="spacingLg" className={css.noRolesWrapper}>
      <NoRolesIllustration />
      <Typography variant="h2">{t("show.parts.engagementNoRoles")}</Typography>
      {showActions && (
        <Inline>
          {canCreateRoles && (
            <>
              {roleKey === TemplateKey.Role && <ApplyEngagementBlueprintButton activityId={activity.id} />}
              <AddRoleButton activityId={activity.id} roleKey={roleKey} />
            </>
          )}
          {activity.coowned && <AddCoOwner activity={activity} />}
        </Inline>
      )}
    </Stack>
  );
};
